export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    this.showButton = !!this.formValues.privacyAgreement && !!this.formValues.termsOfService
  },
})
